/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
import CallTunnelRoutes from "@tunnel-routes/index";
import * as React from "react";
import { Switch } from "react-router-dom";

/**
 * TunnelWatchApplicationRouter  représente l'ensembles des routes
 *  de l'application
 * @function TunnelWatchApplicationRouter
 * @param { } - Les paramètres sont vides
 * @returns { JSX.Element }
 */

const TunnelWatchApplicationRouter: React.FunctionComponent<any> = (): JSX.Element => {
  return <Switch>{true && <CallTunnelRoutes />}</Switch>;
};
/**
 * Exporter cette module à fin d'être utiliser par les
 * autres modules de l'application
 * @export TunnelWatchApplicationRouter
 */
export default TunnelWatchApplicationRouter;



// WEBPACK FOOTER //
// ./src/Router/index.tsx